import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=3ac616ce&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=ts&"
export * from "./Withdrawal.vue?vue&type=script&lang=ts&"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=3ac616ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac616ce",
  null
  
)

export default component.exports